// extracted by mini-css-extract-plugin
export default {"component":"RevenueCommissionTable_component__h-jnt","tableHeader":"RevenueCommissionTable_tableHeader__Jt8Gi","boldFooterRow":"RevenueCommissionTable_boldFooterRow__nxVyg"};